module.exports = __webpack_public_path__ + "static/media/log_6.b8ce30b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/log_6.jpg
// module id = 1895
// module chunks = 0